<template>
    <round
        :percent="getPercent">
    </round>
</template>
<script>
import { mapGetters } from "vuex";
import RoundPercent from "./round-widget";
export default {
    components: {
        "round":RoundPercent
    },
    props: {
        currency:{default:''}
    },
    computed: {
        ...mapGetters({
            getSummary: 'closSummary/getSummary',
        }),
        getPercent() {
            if(!this.getSummary.SumBySymbol)
                return;
            if(this.currency.length === 0) {
                let allDeals = 0;
                let allProfitDeals = 0;
                for (let key in this.getSummary.SumBySymbol) {
                    allDeals+=this.getSummary.SumBySymbol[key].Count
                    allProfitDeals+=this.getSummary.SumBySymbol[key].CountProfit
                }
                let percent = 100/(allDeals/allProfitDeals);
                return Math.floor(percent);
            }
            else {
                let deals = this.getSummary.SumBySymbol[this.currency].Count;
                let profitDelas = this.getSummary.SumBySymbol[this.currency].CountProfit
                let percent = 100/(deals/profitDelas);
                return percent.toFixed();
            }
        }
    },
    created() {
        this.$store.dispatch("closSummary/initialize");
    }
}
</script>
